import React from 'react';
import { ErrorMessage, MessageWrapper } from '@atlaskit/form';
import { fg } from '@atlaskit/platform-feature-flags';
import { ErrorWrapper } from './questionWrappers';
export var QuestionErrorMsg = function QuestionErrorMsg(_ref) {
  var validationErrors = _ref.validationErrors;
  return fg('a11y_error_messages') ? /*#__PURE__*/React.createElement(ErrorWrapper, null, /*#__PURE__*/React.createElement(MessageWrapper, null, validationErrors && /*#__PURE__*/React.createElement(ErrorMessage, null, validationErrors.map(function (validationError) {
    return /*#__PURE__*/React.createElement("span", {
      key: validationError.key
    }, validationError.message, "\xA0");
  }), "\xA0"))) : /*#__PURE__*/React.createElement(ErrorWrapper, null, validationErrors && /*#__PURE__*/React.createElement(ErrorMessage, null, validationErrors.map(function (validationError) {
    return /*#__PURE__*/React.createElement("span", {
      key: validationError.key
    }, validationError.message, "\xA0");
  }), "\xA0"));
};